import { css } from '@emotion/react';
import { Banner } from 'client/components/Banner';

export const ErrorBanner = ({
  error = 'Something went wrong. Please try again…',
  result,
}: {
  error?: string;
  result?: { status?: string };
}) => {
  const status = result?.status || null;

  return (
    <Banner type="error">
      <span css={statusErrorStyle}>
        {error}
        {status && <span css={statusErrorStatusStyle}>{status}</span>}
      </span>
    </Banner>
  );
};

const statusErrorStyle = css`
  position: relative;
  display: block;
  padding-bottom: 1.1rem;
`;

const statusErrorStatusStyle = css`
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0.35;
`;
